const {h, render, Component} = require('preact');
const Recaptcha = require('../recaptcha/preact-recaptcha')

let recaptchaInstance;


class GRecaptcha extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(response) {
    this.props.onRecaptchaDone(recaptchaInstance,response)
  }

  render() {
    let {props} = this;
    window.recaptchaOptions = {lang: I18n.locale};
    return (
        <Recaptcha
          ref={(e) => { 
            recaptchaInstance = e
            props.setRecaptchaInstance(recaptchaInstance);
          }}
          id="web_recaptcha"
          sitekey={Groupon.Utils.getConfigFromDom().recaptcha_site_key}
          onChange={this.onChange}
          size="invisible"
        />
    )
  }
}

module.exports = GRecaptcha
